import styled from 'styled-components';

export const Wrapper = styled.div<{ open: boolean }>`
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	background-color: #0000006a;
	z-index: 9999;
	${({ open }) =>
		!open &&
		`
        display: none;
    `}
`;

export const ModalContainer = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 95%;
	max-width: 500px;
	height: 70%;
	background: white;
	box-shadow: 0 0 20px #00000052;
	border-radius: 5px;
`;

export const ModalTitlebar = styled.div`
	height: 60px;
	width: 100%;
	background: #0072bb;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	padding: 0 10px;
	border-radius: 5px 5px 0 0;
	svg {
		fill: #fff;
	}
`;

export const HeadingFont = styled.p`
	font-weight: 600;
	margin-top: 14px;
	font-size: 18px;
	padding: 0 20px;
	text-align: center;
`;

export const ItemsContainer = styled.div`
	display: flex;
	flex-flow: column nowrap;
	width: 100%;
	max-height: 70%;
	overflow-y: auto;
	scrollbar-width: thin;
`;

export const ItemContainer = styled.div`
	display: flex;
	flex-flow: column;
	margin: 10px 15px;
	border-bottom: 1px solid #e6e6e6;
	& > p {
		margin: 0;
		color: #828282;
	}
`;

export const ItemDetailsContainer = styled.div`
	display: flex;
	justify-content: space-between;
	p {
		margin: 0;
		font-weight: 600;
		font-size: 16px;
	}
`;

export const ItemTitleFont = styled.div`
	margin: 0;
	color: #4e4e4e;
	font-size: 16px;
	max-width: 80%;
`;

export const SummaryFont = styled.p`
	text-align: center;
	font-size: 18px;
	font-weight: 600;
	background: #f8f8f8;
	margin: 17px 7px;
	border-radius: 3px;
	padding: 5px 0;
	position: absolute;
	width: calc(100% - 14px);
	bottom: -10px;
`;
